<div class="step-container registration-failure-page">
  <div class="registration-content">
    <h5 class="registration-failure-page-title">{{ 'fgbcl.registration.failure.page.title' | translate }}</h5>
    <p
      class="registration-failure-message"
      [innerHTML]="'fgbcl.registration.failure.page.message' | translate | markdownTranslate"
    ></p>
    <a class="btn back-btn" [routerLink]="['/login']">{{ 'fgbcl.registration.failure.page.ok.button' | translate }}</a>
  </div>
</div>
